var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.code === 'en')?_c('span',{staticClass:"flag-icon flag-icon-squared",class:"flag-icon-gb"}):_c('span',{staticClass:"flag-icon flag-icon-squared",class:("flag-icon-" + _vm.code)})}
var staticRenderFns = []

export { render, staticRenderFns }